import DisplayBoolean from "./DisplayBoolean.vue";

export { DisplayBoolean };
